import React from 'react';

import styled from '@emotion/styled';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from '@mui/material';
import {
  appEvents, fields
} from 'modules';

import * as dataService from './dataService';



const ControlledTextField = fields.genTextFieldControllerComponent<dataService.IFormData>();
const StyledTypography = styled(Typography)({
  color: 'red'
});


export const FC: React.FC = () => {
  const {
    form,
    loading,
    mutations,
    queries,
    data
  } = dataService.useAddSuperAdminModal();



  function handleClose() {
    appEvents.broadcast({
      type: 'modal',
      args: 'close'
    });
  }



  async function processSubmit(data: dataService.IFormData) {
    const isInUse = await queries.verifyEmailNotInUseQuery(data.email);
    if (!isInUse) {
      await mutations.inviteSuperAdmin(data);
      handleClose();
    }
  }



  return (
    <Dialog
      open
      onClose={handleClose}>
      <DialogTitle>
        Add Super Admin
      </DialogTitle>

      <form onSubmit={form.handleSubmit(processSubmit)}>
        <DialogContent>
          <Grid
            container
            spacing={2}>
            <Grid item xs={12}>
              <Typography>
                Please enter the following information below to add a Super Admin to the platform.
              </Typography>
            </Grid>

            <Grid
              item
              xs={5}>
              <ControlledTextField
                formControl={form.control}
                isDisabled={loading}
                label="First Name"
                fieldKey="firstName" />
            </Grid>

            <Grid
              item
              xs={5}>
              <ControlledTextField
                formControl={form.control}
                isDisabled={loading}
                label="Last Name"
                fieldKey="lastName" />
            </Grid>

            <Grid
              item
              xs={12}>
              <ControlledTextField
                formControl={form.control}
                isDisabled={loading}
                label="Email"
                fieldKey="email" />

              {data.emailInUse && (
                <StyledTypography>
                  Email is in use
                </StyledTypography>
              )}
            </Grid>

            <Grid
              item
              xs={6}>
              <ControlledTextField
                formControl={form.control}
                isDisabled={loading}
                label="Password"
                fieldKey="password" />
            </Grid>

            <Grid
              item
              xs={6}>
              <ControlledTextField
                formControl={form.control}
                isDisabled={loading}
                label="Confirm Password"
                fieldKey="confirmPassword" />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClose}>
            Cancel
          </Button>

          <Button type="submit">
            Confirm
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
